import React, { Component } from "react";
import { Container,  Button, Modal, Form } from "react-bootstrap";
import Select from 'react-select';
import CreatableSelect from "react-select/creatable";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSyncAlt} from "@fortawesome/free-solid-svg-icons";
import PhoneInput, { formatPhoneNumber, formatPhoneNumberIntl, isPossiblePhoneNumber, isValidPhoneNumber } from 'react-phone-number-input';
import 'react-phone-number-input/style.css';

import LocalStorageService from "../../../services/LocalStorageService";
import IdentityService from "../../../services/IdentityService";


const components = {DropdownIndicator: null};

const createOption = (label) => ({
    label,
    value: label,
  });

  /*
  function toSubscriberId(name, gcid)
  {
      var result = gcid + ":" + name.replace(/\s+/g, '');
      return result.toLowerCase().trim();
  }
    */

  function cleanValue(val)
  {
      return (val) ? val.trim() : "";
  }

  function emailIsValid (email) 
  {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
  }



export default class ModalSubscriberDialog extends Component 
{

    constructor(props) {
        super(props);
        this.state = {
 
            options: [],
            // we KNOW the following will be required
            allSubscriberTypes: [],
            allRules: [],
            selectedRules: [],
            allDocuments: [],
            selectedDocuments: [],
            allFilters: [],
            selectedFilters: [],

            isWorking: false,

            // damn error messages
            subscriberNameErr: "",
            subscriberEmailErr: "",
            subscriberPhoneErr: "",
            subscriberRanchErr: "",
            subscriberTypeErr: "",

            subscriberRuleErr: "",
            subscriberDocErr: ""

        }

        this.initDialog = this.initDialog.bind(this);
        this.onFormValueChange = this.onFormValueChange.bind(this);

        this.fetchAllSubscriberTypeOptions = this.fetchAllSubscriberTypeOptions.bind(this);
        this.fetchAllRuleOptions = this.fetchAllRuleOptions.bind(this);
        this.fetchSubscriberRuleOptions = this.fetchSubscriberRuleOptions.bind(this);
        this.fetchAllDocumentOptions = this.fetchAllDocumentOptions.bind(this);
        this.fetchSubscriberDocumentOptions = this.fetchSubscriberDocumentOptions.bind(this);
        this.fetchAllFilterOptions = this.fetchAllFilterOptions.bind(this);
        this.fetchSubscriberFilterOptions = this.fetchSubscriberFilterOptions.bind(this);
        this.fetchEmptySubscriberFilterOptions = this.fetchEmptySubscriberFilterOptions.bind(this);

        this.onSubscriberTypeValueChange = this.onSubscriberTypeValueChange.bind(this);
        this.onDocumentValueChange = this.onDocumentValueChange.bind(this);
        this.onRuleValueChange = this.onRuleValueChange.bind(this);

        this.onTypeInInputValueChange = this.onTypeInInputValueChange.bind(this);
        this.onTypeInValueChange = this.onTypeInValueChange.bind(this);
        this.onTypeInKeyDown = this.onTypeInKeyDown.bind(this);

        this.onPhoneNbrChange = this.onPhoneNbrChange.bind(this);
        this.validateSubscriber = this.validateSubscriber.bind(this);
        this.postSubscriber = this.postSubscriber.bind(this); 


        this.localStorageService = new LocalStorageService();

    }

    componentDidUpdate(prevProps, prevState)
    {
        if (prevProps.showSubscriberModal !== this.props.showSubscriberModal)
        {
            if (this.props.showSubscriberModal)
            {
                this.initDialog();
            }
        }
    }

    initDialog()
    {
    
        // clear out state values
        this.setState({

            // initialize options lists
            allRules: this.fetchAllRuleOptions(),
            allDocuments: this.fetchAllDocumentOptions(),
            allFilters: this.fetchAllFilterOptions(),
            allSubscriberTypes: this.fetchAllSubscriberTypeOptions(),

            subscriberNameErr: "",
            subscriberEmailErr: "",
            subscriberPhoneErr: "",
            subscriberRanchErr: "",
            subscriberRuleErr: "",
            subscriberSchemaErr: "",
            subscriberLocationErr: "",
            subscriberDocErr: "",
        });
        if (this.props.editMode === "add")
        {
            this.setState({
                isWorking: false,
                subscriberName: "",
                subscriberType: "",
                subscriberCompany: "",
                subscriberPhone: "",
                subscriberPosition: "",
                subscriberEmail: "",
                subscriberComments: "",
                // will always have these
                selectedRules: [],
                selectedDocuments: [],
                // the filters will all be empty to start with
                selectedFilters: this.fetchEmptySubscriberFilterOptions()

            });
        }
        else // update
        {
            this.setState(
                {
                    subscriberName: this.props.currentSubscriber.name,
                    subscriberType: this.props.currentSubscriber.subscriberType,
                    subscriberCompany: this.props.currentSubscriber.company,
                    subscriberPhone: this.props.currentSubscriber.transportInfo.sms.address,
                    subscriberPosition: this.props.currentSubscriber.position,
                    subscriberEmail: this.props.currentSubscriber.transportInfo.email.address,
                    subscriberComments: this.props.currentSubscriber.comments,  
                    selectedRules: this.fetchSubscriberRuleOptions(),
                    selectedDocuments: this.fetchSubscriberDocumentOptions(),
                    selectedFilters: this.fetchSubscriberFilterOptions()
                }
            );
        }
    }


    onFormValueChange(e)
    {
        this.setState({ [e.target.id]: e.target.value })
    }

    onPhoneNbrChange(val)
    {
        this.setState({subscriberPhone: val});
    }

    onSubscriberTypeValueChange(opts)
    {
        this.setState({subscriberType: opts.value});
    }

    onDocumentValueChange(opts)
    {
        //var newOpts = (Array.isArray(opts) ? opts.map(x => x.value) : []);
        this.setState({selectedDocuments: opts})
    }

    onRuleValueChange(opts)
    {
        //var newOpts = (Array.isArray(opts) ? opts.map(x => x.value) : []);
        this.setState({selectedRules: opts})
    }

    onFilterDropdownValueChange(id, opts)
    {
        // find the correct filter
        //{id, description, options}
        var selectedFilters = this.state.selectedFilters;
        var selectedFilter = selectedFilters.find((sf) => sf.id === id);
        // if we've created our selectedFilters properly, then this should never happen. If it 
        // does, then just add the new selected filter to the bottom of the array. 
        if (!selectedFilter)
        {
            selectedFilters.push({id: sf.name, description: sf.name, options: opts, typeInInputValue: ""});
        }
        else
        {
            // should be a value that is a REFERENCE to the selectedFilters array element
            selectedFilter.options = opts;
        }
        this.setState({selectedFilters: selectedFilters});

    }

    onTypeInInputValueChange(newInputValue, id)
    {
        var selectedFilters = this.state.selectedFilters;
        var selectedFilter = selectedFilters.find((sf) => sf.id === id);
        // if we've created our selectedFilters properly, then this should never happen. If it 
        // does, then just add the new selected filter to the bottom of the array. 
        if (!selectedFilter)
        {
            selectedFilters.push({id: sf.name, description: sf.name, options: opts, typeInInputValue: newInputValue});
        }
        else
        {
            // should be a value that is a REFERENCE to the selectedFilters array element
            selectedFilter.typeInInputValue = newInputValue;
        }
        this.setState({selectedFilters: selectedFilters});
        //this.setState({blockInputValue: newInputValue});
    }

    onTypeInValueChange(newValue, id)
    {
        var selectedFilters = this.state.selectedFilters;
        var selectedFilter = selectedFilters.find((sf) => sf.id === id);
        // if we've created our selectedFilters properly, then this should never happen. If it 
        // does, then just add the new selected filter to the bottom of the array. 
        if (!selectedFilter)
        {
            selectedFilters.push({id: sf.name, description: sf.name, options: opts, typeInInputValue: ""});
        }
        else
        {
            // should be a value that is a REFERENCE to the selectedFilters array element
            selectedFilter.options = newValue;
        }
        this.setState({selectedFilters: selectedFilters});
        //this.setState({blockValue: newValue});
    }

    onTypeInKeyDown(ev, id)
    {
        var selectedFilters = this.state.selectedFilters;
        var selectedFilter = selectedFilters.find((sf) => sf.id === id);
        var val = selectedFilter.options;
        var inputVal = selectedFilter.typeInInputValue;
        if (!inputVal) return;

        //const { blockInputValue, blockValue } = this.state;
        //if (!blockInputValue) return; // we haven't entered anything yet so don't do any major actions
        switch(ev.key)
        {
            case 'Enter':
            case 'Tab':
                selectedFilter.typeInInputValue = ""; // reset the input Value
                selectedFilter.options = [...val, createOption(inputVal)]; // assign the value
                this.setState({selectedFilters: selectedFilters});
                /*
                this.setState({
                    blockInputValue: '',  // reset the blockInputValue
                    blockValue: [...blockValue, createOption(blockInputValue)], // use the current state blockInputValue as a new value
                  });
                */
                ev.preventDefault(); // don't actually the keystroke
        }
    }


 





    validateSubscriber(subscriber)
    {
        var subscription = subscriber.subscriptions.find((s) => s.name === this.props.currentSubscriptionId);
        var subscriberNameErr = (subscriber.name === "") ? "*You must enter a Name" : "";
        subscriberNameErr = (subscriber.name !== "" && subscriber.name.length<6) ? "* Your name must be at least 6 characters" : subscriberNameErr;
        if ((this.props.editMode === "add") && !(subscriberNameErr))
        {
            var exists = this.props.existingNames.some((n) =>  n.toLowerCase().trim() === subscriber.name.toLowerCase().trim());
            if (exists)
            {
                subscriberNameErr = "There is already a subscriber with the name " + subscriber.name;
            }
        }
        var subscriberTypeErr = ((!subscriber.subscriberType) || (subscriber.subscriberType.trim()==="")) ? "*Please select a subscriber type" : "";
        var subscriberDocErr = (subscription.documents.length < 1) ? "*You must select at least one document" : "";
        var subscriberRuleErr = (subscription.rules.length < 1) ? "*You must select at least one rule" : "";
        var subscriberEmailErr = "";
        var subscriberPhoneErr = "";
        // check that the user has entered the transport info we need to support the docs they want
        var hasEmailAddress = (subscriber.transportInfo?.email?.address);
        var hasSmsAddress = (subscriber.transportInfo?.sms?.address);
        this.state.selectedDocuments.forEach((doc) =>{
            var selectedDocument = this.props.subscriptionOrgSchema.documents.find((sd) => sd.id === doc.value);
            if ((selectedDocument.transportType.toLowerCase()==="email") && (!hasEmailAddress))
            {
                 subscriberEmailErr = "*The document(s) you selected require an email address";
            }
            if ((selectedDocument.transportType.toLowerCase()==="sms") && (!hasSmsAddress))
            {
                 subscriberPhoneErr = "*The document(s) you selected require an phone number";
            }    
        })
        if ((!subscriberPhoneErr) && (hasSmsAddress))
        {
            if (subscriber.transportInfo.sms.address.trim() !== "")
            {
                if (!isPossiblePhoneNumber(subscriber.transportInfo.sms.address.trim()))
                {
                subscriberPhoneErr = "*This appears to be an invalid phone number";
                }
            }
        }
        if ((!subscriberEmailErr) && (hasEmailAddress))
        {
            if (subscriber.transportInfo.email.address.trim() !== "")
            {
                if (!emailIsValid(subscriber.transportInfo.email.address.trim()))
                {
                    subscriberEmailErr = "*This appears to be an invalid email address";
                }    
            }
        }

       this.setState(
           {
               subscriberNameErr: subscriberNameErr,
               subscriberTypeErr: subscriberTypeErr,
               subscriberDocErr: subscriberDocErr,
               subscriberRuleErr: subscriberRuleErr,
               subscriberEmailErr: subscriberEmailErr,
               subscriberPhoneErr: subscriberPhoneErr
           }
       )

       return ((subscriberNameErr === "") && (subscriberTypeErr === "") && (subscriberDocErr === "") 
        && (subscriberRuleErr === "") && (subscriberEmailErr === "") && (subscriberPhoneErr === ""));
    }



    async postSubscriber()
    {
        this.setState({isWorking: true});
        // validate
        var gcid = (this.props.userSession) ? this.props.userSession.gcid : "";
        var formattedPhoneNbr = cleanValue(this.state.subscriberPhone); //this.cleanPhoneNbr(this.state.subscriberPhone);
        var subscriber = {
            "id": (this.props.editMode === "add") ? IdentityService.makeUuid(): this.props.currentSubscriber.id, // new
            "gcid": gcid, 
            "name": cleanValue(this.state.subscriberName),
            "subscriberId": cleanValue(this.state.subscriberName), 
            "company": cleanValue(this.state.subscriberCompany), 
            "subscriberType": cleanValue(this.state.subscriberType),
            "position": cleanValue(this.state.subscriberPosition),
            "comments": cleanValue(this.state.subscriberComments),
            "isActive": true
        };
        subscriber.transportInfo = {email: {address: cleanValue(this.state.subscriberEmail)}, sms: {address: formattedPhoneNbr}};
        var subscription = {
            name: this.props.currentSubscriptionId,
            documents: Array.isArray(this.state.selectedDocuments) ? this.state.selectedDocuments.map(d => d.value) : [],
            rules: Array.isArray(this.state.selectedRules) ? this.state.selectedRules.map(d => d.value) : [],
            selections: []
        };
        this.props.subscriptionOrgSchema.subscriberFilters.selectionTriggers.forEach((st) => {
            var triggerName = st.metadata.name;
            var subscriberFilter = this.state.selectedFilters.find((sf) => sf.id === triggerName);
            // it SHOULD be there, even if it's empty. 
            var values = (subscriberFilter.options<1) ? "" : subscriberFilter.options.map((sfo) => {return sfo.value});
            if ((!values) || (values.length<1))
            {
                values = ["ALL"];
            }
            subscription.selections.push({name: triggerName, values: values});
        });

        subscriber.subscriptions = [subscription];

        if (!this.validateSubscriber(subscriber))
        {
            this.setState({isWorking: false});
            return;
        }

        var postResult = (this.props.editMode === "add")  ? 
            await this.props.postNew(subscriber) 
            : await this.props.postUpdated(subscriber);

        this.setState({isWorking: false});
    }

    fetchAllSubscriberTypeOptions()
    {
        var listData = this.localStorageService.getDataList("subscriptionTypes", this.props.userSession.gcid);
        var allOptions = listData.data.data.map((l) => {return {value: l.id, label: l.name}});
        return allOptions;

    }

    

    /* Get data from "standard" lists - these are the ones we KNOW we are going to use */
    fetchAllRuleOptions()
    {
        var allOptions = this.props.subscriptionOrgSchema.rules.map((r) => {
            return {value: r.metadata.name, label: r.metadata.name + "-" + r.metadata.description};
        })
        return allOptions;
    }

    fetchSubscriberRuleOptions()
    {
        // find the subscription. It's possible that this user has never subscribed to this particular subscription
        var subscription = this.props.currentSubscriber.subscriptions.find((s) => s.name === this.props.currentSubscriptionId);
        if (!subscription) return [];
        if ((!subscription.rules) || (!Array.isArray(subscription.rules))) return [];
        var result = [];
        // let the org schema drive. If we no longer support a document, then we don't want to include it after editing. 
        this.props.subscriptionOrgSchema.rules.forEach((orgRule) =>
        {
            if (subscription.rules.some((subRule) => subRule === orgRule.metadata.name))
            {
                result.push({value: orgRule.metadata.name, label: orgRule.metadata.name + "-" + orgRule.metadata.description});
            }
        })
        return result;
    }

    fetchAllDocumentOptions()
    {
        var allOptions = this.props.subscriptionOrgSchema.documents.map((d) => {
            return {value: d.id, label: d.description};
        })
        return allOptions;
    }

    fetchSubscriberDocumentOptions()
    {
        // find the subscription. It's possible that this user has never subscribed to this particular subscription
        var subscription = this.props.currentSubscriber.subscriptions.find((s) => s.name === this.props.currentSubscriptionId);
        if (!subscription) return [];
        if ((!subscription.documents) || (!Array.isArray(subscription.documents))) return [];
        var result = [];
        // let the org schema drive. If we no longer support a document, then we don't want to include it after editing. 
        this.props.subscriptionOrgSchema.documents.forEach((orgDoc) =>
        {
            if (subscription.documents.some((subDoc) => subDoc === orgDoc.id))
            {
                result.push({value: orgDoc.id, label: orgDoc.description});
            }
        })
        return result;
    }


    /* get filter property lists */

    fetchAllFilterOptions()
    {
        // this is an ARRAY of the values because they can be dynamic based on what filters are part of the subscription
        var allFilters = this.props.subscriptionOrgSchema.subscriberFilters.selectionTriggers.map((f) => {
            // at this point, assume it's a dropdown
            // are options defined, or is this a datalist we need to fetch?
            var allOptions;

            if (f.dataList)
            {
                var listData = this.localStorageService.getDataList(f.dataList, this.props.userSession.gcid);
                allOptions = listData.data.data.map((l) => {return {value: l.id, label: l.name}})
            }
            else if (f.options)
            {
                allOptions = f.options.map((o) => {return {value: o.id, label: o.value}});
            }
            else
            {
                // this must NOT be a dropdown (probably a typeIn). For now just create an empty list.
                allOptions = [{value: "", label: ""}];
            }
            if (f.allowAll){
                allOptions.unshift({value: "ALL", label: "All"});
            }
            return {id: f.metadata.name, description: f.metadata.description, type: f.fieldType, options: allOptions};
        });
        return allFilters;
    }


    fetchEmptySubscriberFilterOptions()
    {
        var subscriberFilters = this.props.subscriptionOrgSchema.subscriberFilters.selectionTriggers.map((f) => {
            return {id: f.metadata.name, description: f.metadata.description, options: [], typeInInputValue: ""};
        });
        return subscriberFilters;
    }
   

    fetchSubscriberFilterOptions()
    {
        var result = [];
        var subscription = this.props.currentSubscriber.subscriptions.find((s) => s.name === this.props.currentSubscriptionId);
        if (!subscription) return this.fetchEmptySubscriberFilterOptions();
        if ((!subscription.selections) || (!Array.isArray(subscription.selections))) return this.fetchEmptySubscriberFilterOptions();
        // make sure we get ALL of the current schema filters. Maybe one was added or removed since this user last was created/edited.
        var allFilters = this.props.subscriptionOrgSchema.subscriberFilters.selectionTriggers.map((st) => {return {id: st.metadata.name, description: st.metadata.description}});
        allFilters.forEach((filter) =>{
            var subscriberFilter = subscription.selections.find((selection) => selection.name === filter.id);
            if (!subscriberFilter)
            {
                result.push({id: filter.id, description: filter.description, options: [], typeInInputValue: ""})
            }
            else {
                result.push({id: filter.id, description: filter.description, options: subscriberFilter.values.map((v) => {return {value: v, label: v}}), typeInInputValue: ""});
            }
        });
        return result;  
    }

    




    /* END lists */
    









  


    render() 
    {

        var loadingOptions = [{"value": "", "label": "Loading..."}];

            const workingButtonIcon = this.state.isWorking ? (
                <FontAwesomeIcon icon={faSyncAlt} color="green" spin />
              ) : (
                "Ok"
              );

        var subscriberTypeOptions = (this.state.subscriberType) ? {id: this.state.subscriberType, label: this.state.subscriberType} : {id: "", label: ""};



        // build dynamic filter UI
        var filterComponents = [];
        this.state.allFilters.forEach((af) =>
        {
            console.log("allFilters");
            console.info(this.state.allFilters);
            console.log("selectedFilters");
            console.info(this.state.selectedFilters);
            var selectedFilter = this.state?.selectedFilters.find((sf) => sf.id === af.id);
            var optValues = (selectedFilter) ? selectedFilter.options: [];
            var inputValue = (selectedFilter) ? selectedFilter.typeInInputValue: "";
            var filterComponent = (af.type === "dropdown") ?
            
            <Form.Group className="mb-3">
            <Form.Text className="text-muted">
                {af.id.toLowerCase()}&nbsp;<span style={{color: "red"}}>{this.state.subscriberFilterErr}</span>
            </Form.Text>
            <Select
                id={af.id}
                key={af.id}
                autoFocus
                placeholder={ af.id}
                options={(af.options) ? af.options: loadingOptions}
                onChange={opts => this.onFilterDropdownValueChange(af.id, opts)}
                isSearchable={true}
                isMulti={true}
                value={optValues}
            />
        </Form.Group>
        :
        <Form.Group className="mb-3">
        <Form.Text className="text-muted">
            {af.id.toLowerCase()}&nbsp;<span style={{color: "red"}}>{this.state.subscriberFilterErr}</span>
        </Form.Text>
    <CreatableSelect
        id={af.id}
        components={components}
        inputValue={inputValue}
        isClearable
        isMulti
        menuIsOpen={false}
        onChange={(newValue) => this.onTypeInValueChange(newValue, af.id)}      //{this.handleBlockChange}
        onInputChange={(newInputValue) => this.onTypeInInputValueChange(newInputValue, af.id)}
        onKeyDown= {(ev) => this.onTypeInKeyDown(ev, af.id)}  //{this.handleBlockKeyDown}
        placeholder="Type in a value and press enter..."
        value={optValues}
    /> 
    </Form.Group>



        filterComponents.push(filterComponent);
        })

        if (filterComponents.length > 0)
        {
            var fcCount = filterComponents.length;
        }




        return (
            <Modal
                show={this.props.showSubscriberModal}
                onHide={this.props.closeSubscriberModal}
            >
                <Modal.Header closeButton>
                    <Modal.Title>New Subscriber Entry/Edit</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Container>
                        <Form>
                            <Form.Group className="mb-3">
                                <Form.Text className="text-muted">
                                     name of new subscriber&nbsp;<span style={{color: "red"}} >{this.state.subscriberNameErr}</span>
                                </Form.Text>
                                <Form.Control id="subscriberName" type="text" placeholder="Name" value={this.state.subscriberName} onChange={(e) => this.onFormValueChange(e)}/>
                            </Form.Group>

                            <Form.Group className="mb-3">
                                <Form.Text className="text-muted">
                                    subscriber type&nbsp;<span style={{color: "red"}}>{this.state.subscriberTypeErr}</span>
                                </Form.Text>
                                <Select
                                    id="subscriberType"
                                    autoFocus
                                    placeholder={"Select Subscriber Type"}
                                    options={(this.state.allSubscriberTypes) ? this.state.allSubscriberTypes: loadingOptions}
                                    onChange={opts => this.onSubscriberTypeValueChange(opts)}
                                    isSearchable={true}
                                    isMulti={false}
                                    value={subscriberTypeOptions}
                                />
                            </Form.Group>

                            <Form.Group className="mb-3">
                                <Form.Text className="text-muted">
                                     company
                                </Form.Text>
                                <Form.Control id="subscriberCompany" type="text" placeholder="Company"  value={this.state.subscriberCompany} onChange={(e) => this.onFormValueChange(e)}/>
                            </Form.Group>
                            <Form.Group className="mb-3">
                                <Form.Text className="text-muted">
                                    position
                                </Form.Text>
                                <Form.Control id="subscriberPosition" type="text" placeholder="Position" value={this.state.subscriberPosition}  onChange={(e) => this.onFormValueChange(e)}/>
                            </Form.Group>
                            <Form.Group className="mb-3">
                                <Form.Text className="text-muted">
                                    email&nbsp;<span style={{color: "red"}}>{this.state.subscriberEmailErr}</span>
                                </Form.Text>
                                <Form.Control id="subscriberEmail" type="email" placeholder="Email" value={this.state.subscriberEmail}  onChange={(e) => this.onFormValueChange(e)}/>
                            </Form.Group>
                            <Form.Group className="mb-3">
                                <Form.Text className="text-muted">
                                    phone number&nbsp;<span style={{color: "red"}}>{this.state.subscriberPhoneErr}</span>
                                </Form.Text>
                                <PhoneInput
                                    defaultCountry="US"
                                    placeholder="phone number"
                                    value={this.state.subscriberPhone}
                                    onChange={this.onPhoneNbrChange}
                                />
                            </Form.Group>

                            <Form.Group className="mb-3">
                                <Form.Text className="text-muted">
                                    rules&nbsp;<span style={{color: "red"}}>{this.state.subscriberRuleErr}</span>
                                </Form.Text>
                                <Select
                                    autoFocus
                                    placeholder={"Select Trigger Rules"}
                                    options={(this.state.allRules) ? this.state.allRules: loadingOptions}
                                    onChange={opts => this.onRuleValueChange(opts)}
                                    isSearchable={true}
                                    isMulti={true}
                                    value={this.state.selectedRules}
                                />
                            </Form.Group>

                            <Form.Group className="mb-3">
                                <Form.Text className="text-muted">
                                    documents&nbsp;<span style={{color: "red"}}>{this.state.subscriberDocErr}</span>
                                </Form.Text>
                                <Select
                                    autoFocus
                                    placeholder={"Select Subscription Documents"}
                                    options={(this.state.allDocuments) ? this.state.allDocuments : loadingOptions}
                                    onChange={opts => this.onDocumentValueChange(opts)}
                                    isSearchable={true}
                                    isMulti={true}
                                    value={this.state.selectedDocuments}
                                />
                            </Form.Group>


                            {/*
                            <Form.Group className="mb-3">
                                <Form.Text className="text-muted">
                                    growers&nbsp;<span style={{color: "red"}}>{this.state.subscriberRanchErr}</span>
                                </Form.Text>
                            <CreatableSelect
                                components={components}
                                inputValue={blockInputValue}
                                isClearable
                                isMulti
                                menuIsOpen={false}
                                onChange={this.handleBlockChange}
                                onInputChange={this.handleBlockInputChange}
                                onKeyDown={this.handleBlockKeyDown}
                                placeholder="Type in a Grower Id and press enter..."
                                value={blockValue}
                            /> 
                            </Form.Group>
                            */}


                            {filterComponents.map(comp => {
                                return (comp);
                            })}

 

                            <Form.Group className="mb-3">
                                <Form.Text className="text-muted">
                                    comments
                                </Form.Text>
                                <Form.Control id="subscriberComments" type="text" placeholder="Comments" value={this.state.subscriberComments}  onChange={(e) => this.onFormValueChange(e)}/>
                            </Form.Group>
                        </Form>
                    </Container>
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        variant="secondary"
                        disabled={this.state.isWorking}
                        onClick={(e) => this.postSubscriber(e)}
                    >
                        {workingButtonIcon}
                    </Button>
                    <Button
                        variant="secondary"
                        disabled={this.state.isWorking}
                        onClick={this.props.closeSubscriberModal}
                    >
                        Cancel
                    </Button>
                </Modal.Footer>
            </Modal>
        );
    }
}
